import { useEffect, useState } from "react";
import api from "@/lib/api";
import { History } from "lucide-react";

const LABELS = {
  event_promoter_confirmed: "confirmou",
  event_promoter_suplente: "adicionou como suplente",
  event_promoter_removed: "removeu/dispensou",
  event_promoter_readmitted: "readmitiu",
  event_promoter_inbox_response: "registou resposta (Inbox) de",
};

const fmt = (iso) => new Date(iso).toLocaleString("pt-PT", { dateStyle: "short", timeStyle: "short" });

export default function EventActivityCard({ eventId, promoterMap, version }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get(`/events/${eventId}/activity`).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [eventId, version]);

  if (!items.length) return null;
  return (
    <div className="bg-white border border-zinc-200 rounded-2xl p-5" data-testid="event-activity-card">
      <h3 className="font-display font-bold text-zinc-950 flex items-center gap-2 mb-3">
        <History className="w-4 h-4" /> Histórico de ações
      </h3>
      <ul className="space-y-1.5 text-sm max-h-64 overflow-y-auto">
        {items.map((a) => {
          const md = a.metadata || {};
          const who = md.user_name || md.user_email || "Utilizador";
          const pname = promoterMap[md.promoter_id]?.name || md.promoter_name || "promotor";
          return (
            <li key={a.id} className="text-zinc-700" data-testid={`event-activity-${a.id}`}>
              <span className="text-zinc-400 tabular-nums mr-2">{fmt(a.created_at)}</span>
              <strong>{who}</strong> {LABELS[a.action] || a.action} <strong>{pname}</strong>
              {md.status ? ` (${md.status})` : ""}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
